import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import indoorHelper from "../../store/helpers/indoorHelper";
import NoMapViewCard from "../../components/noMapViewCard/NoMapViewCard";
import { setIndoorMapSearchText, setIndoorMapSortText, setIsSortClicked, setSearchClicked, } from "../../store/reducers/venuesSlice";
import ListView from "../../pages/ListView/ListView";
import { searchVenueFromList } from "../../api/venuesList";
import Loader from "../../components/loader";
var YourIndoorMap = function () {
    var dispatch = useDispatch();
    var venuesCount = useSelector(function (state) {
        return state.venues.initialVenuesList && state.venues.initialVenuesList.length;
    });
    var venuesListArray = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.initialVenuesList; });
    var venuesList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.list; });
    var indoorMapSearchText = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.indoorMapSearchText; });
    var indoorMapSortText = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.indoorMapSortText; });
    var isSearchClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSearchClicked; });
    var isIndoorMapCreator = indoorHelper.useQuery().get("imc") === "true";
    var _a = useState(venuesListArray), venueState = _a[0], setVenueState = _a[1];
    var isSortClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSortClicked; });
    var _b = useState(true), isLoad = _b[0], setIsLoad = _b[1];
    useEffect(function () {
        if ((isSearchClicked &&
            (indoorMapSearchText || indoorMapSearchText === "")) ||
            (isSortClicked && indoorMapSortText)) {
            dispatch(searchVenueFromList(indoorMapSearchText, indoorMapSortText, null, setVenueState));
        }
    }, [isSearchClicked, indoorMapSearchText, indoorMapSortText, isSortClicked]);
    useEffect(function () {
        isLoad &&
            setTimeout(function () {
                setIsLoad(false);
            }, 500);
        setVenueState(venuesList);
        // if sort text is not modified then initially set it modified
        indoorMapSortText !== "modified" &&
            dispatch(setIndoorMapSortText({
                indoorMapSortText: "modified",
                isSortClicked: false,
            }));
        // if search text is not blank then initially set it blank
        indoorMapSearchText !== "" &&
            dispatch(setIndoorMapSearchText({
                isSearchClicked: false,
                indoorMapSearchText: "",
            }));
        return function () {
            // when unmounting search and sort click needs to be false so that it will not go in searching block on initial load of tab
            setIsSortClicked(false);
            setSearchClicked(false);
        };
    }, []);
    return !isLoad ? (_jsx(_Fragment, { children: venuesCount || isIndoorMapCreator ? (_jsx(ListView, { venueList: venueState, onSortChange: function (sortText) {
                return dispatch(setIndoorMapSortText({
                    indoorMapSortText: sortText,
                    isSortClicked: true,
                }));
            }, searchText: indoorMapSearchText, sortText: indoorMapSortText })) : (_jsx(NoMapViewCard, {})) })) : (_jsx(Loader, {}));
};
export default React.memo(YourIndoorMap);
